
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Helmet } from "react-helmet";

export default function Resources() {
  const resources = [
    {
      name: "National Council of Teachers of Mathematics - Standards",
      url: "https://www.nctm.org/Standards-and-Positions/Principles-and-Standards/Measurement/"
    },
    {
      name: "Leading Mathematics Professional Learning",
      url: "https://sites.google.com/cem.edu.au/leadingmathematicsproflearning/curriculum/measurement/teaching-resources-measurement"
    },
    {
      name: "National Council of Teachers of Mathematics - Resources",
      url: "https://www.nctm.org/resources/"
    },
    {
      name: "NIST",
      url: "https://www.nist.gov/pml/owm"
    },
    {
      name: "Measurement - STEM Learning",
      url: "https://www.stem.org.uk/resources/elibrary/resource/32170/measurement"
    },
    {
      name: "The National Informal STEM Education Network",
      url: "https://www.nisenet.org/"
    },
    {
      name: "The Owl Teacher - 7 Easy Methods to Teach Conversions",
      url: "https://theowlteacher.com/7-easy-methods-to-teach-conversions/"
    },
    {
      name: "Interactive Ways to Teach Measurement",
      url: "https://www.classroomnook.com/blog/interactive-ways-to-teach-measurement"
    },
    {
      name: "The Essential Role of Rulers and Flat Measuring Tools",
      url: "https://lancerulers.com/blogs/news/the-essential-role-of-rulers-and-flat-measuring-tools-in-stem-education"
    }
  ];

  return (
    <div className="container mx-auto px-4 py-8">
      <Helmet>
        <title>Measurement Resources - UnitCodex</title>
        <meta name="description" content="Explore our curated collection of educational resources on measurement systems, unit conversions, and the history of measurement." />
        <link rel="canonical" href="https://unitcodex.com/resources" />
      </Helmet>
      
      <Card className="bg-manuscript-background/90">
        <CardHeader>
          <CardTitle className="text-4xl font-cinzel text-center">Educational Resources</CardTitle>
          <p className="text-center text-manuscript-primary/80 mt-2">
            Curated collection of measurement education resources
          </p>
        </CardHeader>
        <CardContent>
          <ul className="space-y-2">
            {resources.map((resource, index) => (
              <li 
                key={index} 
                className="hover:bg-manuscript-primary/10 hover:translate-x-1 p-3 rounded-lg transition-all duration-200 ease-in-out"
              >
                <a
                  href={resource.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-lg text-manuscript-primary hover:text-manuscript-primary/80 transition-colors block"
                >
                  {resource.name}
                </a>
              </li>
            ))}
          </ul>
        </CardContent>
      </Card>
    </div>
  );
}
